<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
              class="nav-link active"
              v-bind:href="'#t1' + rowData.lay_id + ''"
              role="tab"
              data-toggle="tab"
          >
            <span class="nav-link-in">
              Grupo layout
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              v-bind:href="'#t2' + rowData.lay_id + ''"
              role="tab"
              data-toggle="tab"
              v-if="rowData.layout_unidade.length > 0"
          >
            <span class="nav-link-in">
              Unidades
              <i class="fa fa-home"></i>
            </span>
          </a>
        </li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1' + rowData.lay_id + ''">
          <table class="table-striped" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 5%">Código</th>
                                    <th style="width: 20%">Descrição</th>
                                    <th style="width: 5%">Ordem</th>
                                    <th style="width: 15%">Tipo Grupo</th>
                                    <th style="width: 15%">Grupo Dados</th>
                                    <th style="width: 15%">Grupo Layout Pai</th>
                                    <th style="width: 5%">Layout</th>
                                    <th style="width: 5%">Tag</th>
                                    <th style="width: 5%">Registro</th>
                                    <th style="width: 5%">Status</th>
                                    <th style="width: 5%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                               <template v-for="item in rowData.layout_grupo">
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td >
                                        {{ item.cd }}
                                    </td>
                                    <td >
                                        {{ item.descr }}
                                    </td>
                                    <td >
                                        {{ item.ordem }}
                                    </td>
                                    <td >
                                        {{ item.tp_grupo.descr }}
                                    </td>
                                    <td >
                                      <span v-if="item.b_grupo_dados==null"><i class="fa fa-times"></i></span>
                                      <span v-if="item.b_grupo_dados!==null">{{ item.b_grupo_dados.descr }}</span>
                                    </td>
                                    <td >
                                      <span v-if="item.layout_grupo==null"><i class="fa fa-times"></i></span>
                                      <span v-if="item.layout_grupo!==null">{{ item.layout_grupo.descr }}</span>
                                    </td>
                                    <td >
                                        {{ item.layout.descr }}
                                    </td>
                                    <td >
                                        {{ item.tag }}
                                    </td>
                                    <td >
                                        {{ item.registro }}
                                    </td>
                                    <td>
                                      <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                  <td>
                                    <a @click="onCreate(item)" v-b-tooltip title="Cadastrar Detalhe"><i class="fa fa-plus-square"></i></a>
                                    <a @click="onEditGrupo(item)" v-b-tooltip title="Editar Grupo"><i class="fa fa-edit"></i></a>
                                    <a v-if="item.status.valor==2" @click="onActivateDesactivateGrupo(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                    <a v-if="item.status.valor==1" @click="onActivateDesactivateGrupo(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                    <a @click="onDetailDet(item)" v-if="item.layout_grupo_detalhe.length>0" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                  </td>
                                </tr>
                                <tr v-if="isVisibleDetailRow(item.laygrp_id)">
                                    <td colspan="8">
                                      <div class="nav-vertical">
                                          <ul class="nav nav-tabs nav-topline" role="tablist">
                                                <li class="nav-item">
                                                  <a class="nav-link active" v-bind:href="'#tr1'+item.lgdet_id+''" role="tab" data-toggle="tab">
                                                    <span class="nav-link-in">
                                                  Detalhes
                                                  <i class="fa fa-plus"></i>
                                                </span>
                                              </a>
                                            </li>
                                        </ul>

                            <div class="tab-content">
                                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'tr1'+item.lgdet_id+''">
                                    <table class="table-striped" id="mais">
                                        <thead>
                                          <tr>
                                              <th style="width: 5%">Código</th>
                                              <th style="width: 5%">Ordem</th>
                                              <th style="width: 5%">Campo</th>
                                              <th style="width: 10%">Descrição</th>
                                              <th style="width: 10%">Tamanho</th>
                                              <th style="width: 10%">Formato Campo</th>
                                              <th style="width: 10%">Tipo Campo</th>
                                              <th style="width: 5%">Campo fixo</th>
                                              <th style="width: 5%">Decimais</th>
                                              <th style="width: 5%">Obrigatório</th>
                                              <th style="width: 5%">Máscara Data</th>
                                              <th style="width: 5%">Completa Esquerda</th>
                                              <th style="width: 5%">Completa Direita</th>
                                              <th style="width: 5%">Grupo de dados</th>
                                              <th style="width: 5%">Tag</th>
                                              <th style="width: 5%">Status</th>
                                              <th style="width: 5%">Ações</th>
                                          </tr>
                                          </thead>
                                          <tbody  v-for="item_det in item.layout_grupo_detalhe">
                                              <tr class="bg-gray-light" style="display: table-row;">
                                                 <td>
                                                    {{ item_det.cd }}
                                                 </td>
                                                 <td>
                                                    {{ item_det.ordem }}
                                                 </td>
                                                 <td>
                                                     <span v-if="item_det.b_grupo_dados_campo!==null">{{ item_det.b_grupo_dados_campo.descr }}</span>
                                                 </td>
                                                 <td>
                                                     {{ item_det.descr }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.tamanho }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.formato_campo.descr }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.tp_campo.descr }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.campo_fixo }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.decimais }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.obrigatorio.descr }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.mascara_data }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.completa_esquerda }}
                                                 </td>
                                                 <td>
                                                     {{ item_det.completa_direita }}
                                                 </td>
                                                 <td>
                                                     <span v-if="item_det.b_grupo_dados_campo!==null">{{ item_det.b_grupo_dados_campo.b_grupo_dados.descr }} / {{ item_det.b_grupo_dados_campo.descr }}</span>
                                                 </td>
                                                 <td>
                                                     {{ item_det.tag }}
                                                 </td>
                                                 <td>
                                                   <span class="badge badge-success" v-if="item_det.status.valor==1">{{ item_det.status.descr }}</span>
                                                   <span class="badge badge-danger" v-if="item_det.status.valor==2">{{ item_det.status.descr }}</span>
                                                 </td>
                                               <td>
                                                   <a v-if="item_det.status.valor==2" @click="onActivateDesactivateGrupoDetalhe(1, item_det, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                   <a v-if="item_det.status.valor==1" @click="onActivateDesactivateGrupoDetalhe(2, item_det, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                   <a @click="onEditGrupoDetalhe(item_det)" v-b-tooltip title="Editar detalhe"><i class="fa fa-edit"></i></a>
                                               </td>
                                             </tr>
                                           </tbody>
                                        </table>
                                      </div>
                                  </div>
                              </div>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                       </table>
                  </div><!--.tab-pane-->
          <div
              role="tabpanel"
              class="tab-pane fade pt-1 border-color-detalhes-grey"
              v-bind:id="'t2' + rowData.lay_id + ''"
              v-if="rowData.layout_unidade.length >= 1"
          >
            <table class="table-striped" id="mais">
              <thead>
              <tr>
                <th style="width: 20%">Unidade</th>
                <th style="width: 20%">Status</th>
              </tr>
              </thead>
              <tbody v-for="(item, index) in rowData.layout_unidade">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.unidade.cd }} - {{ item.unidade.descr }}
                </td>
                <td>
                  <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                  <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

       <LayoutGrupoDetalheForm
           ref="layoutgrupodetalheform" :tabela="'layout_grupo_detalhe'" :rota="'layoutgrupodetalhe'">
       </LayoutGrupoDetalheForm>
       <LayoutGrupoForm
           ref="layoutgrupoform" :tabela="'layout_grupo'" :rota="'layoutgrupo'">
       </LayoutGrupoForm>
    </div>
        </div>
    </div>
</template>

  <script>
  import LayoutGrupoDetalheForm from './LayoutGrupoDetalheForm'
  import LayoutGrupoForm from './LayoutGrupoForm'
  export default {
      components: {
          LayoutGrupoDetalheForm,
          LayoutGrupoForm
      },
      data () {
        return {
          visibleDetailRows: [],
          helpForm: new Form({recordCollection: [], status: ''}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
    onCreate (item)
    {
      this.$refs.layoutgrupodetalheform.onCreate(item);
    },
    onEditGrupo (item)
    {
      this.$refs.layoutgrupoform.onEdit(item);
    },
    onEditGrupoDetalhe (item)
    {
      this.$refs.layoutgrupodetalheform.onEdit(item);
    },
      isVisibleDetailRow (rowId) {
        return this.visibleDetailRows.indexOf( rowId ) >= 0
      },
      showDetailRow (rowId) {
        if (!this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.push(rowId)
        }
      },
      hideDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.splice(
            this.visibleDetailRows.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.hideDetailRow(rowId)
        } else {
          this.showDetailRow(rowId)
        }
      },
        onDetailDet(data) {
          this.toggleDetailRow(data.laygrp_id);
        },
        onActivateDesactivateGrupo(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.recordCollection = [];
                this.helpForm.recordCollection.push(data.laygrp_id );
            }
            else
            {
                this.helpForm.recordCollection = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.recordCollection.push(obj)
                });
            }
            this.helpForm.patch('/api/layoutgrupo/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateGrupoDetalhe(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.recordCollection = [];
                this.helpForm.recordCollection.push(data.lgdet_id );
            }
            else
            {
                this.helpForm.recordCollection = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.recordCollection.push(obj)
                });
            }
            this.helpForm.patch('/api/layoutgrupodetalhe/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
  }
}
  </script>
